"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.object.seal");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _upload = _interopRequireDefault(require("./component/upload.vue"));
var _editorForVue = require("@wangeditor/editor-for-vue");
var _ossUpload = require("@/utils/ossUpload");
var _marketingEvents = require("@/api/marketingFunction/marketingEvents");
var _marketingFunction = require("@/api/marketingFunction");
var _ItemActivity = _interopRequireDefault(require("./component/ItemActivity"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketingEvents',
  components: {
    upload: _upload.default,
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar,
    ItemActivity: _ItemActivity.default
  },
  data: function data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      getTljPidUseInfoData: {},
      queryData: {
        activityName: '',
        status: null,
        page: {
          page: 1,
          size: 10
        }
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      eventsType: 'add',
      // 编辑and新增
      // 添加
      dialogVisible: false,
      ruleForm: {
        id: null,
        activityName: '',
        targetUserType: null,
        subsidyNum: null,
        headerPic: '',
        // 头图
        tutorialsSharePic: '',
        // 教程图
        activitySharePic: '',
        // 活动分享海报
        tagPic: '',
        // 标签图
        color: '',
        activityTxt: null,
        // 规则文案
        timeArray: [],
        activityStartTime: '',
        //	活动开始时间
        activityEndTime: '' //	活动结束时间
      },
      rules: {
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        targetUserType: [{
          required: true,
          message: '请选择目标用户',
          trigger: 'change'
        }],
        subsidyNum: [{
          required: true,
          message: '请输入限购次数',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '限购次数必须是数字',
          trigger: ['blur', 'change']
        }],
        headerPic: [{
          required: true,
          message: '请上传头图',
          trigger: 'blur'
        }],
        tutorialsSharePic: [{
          required: true,
          message: '请上传教程图',
          trigger: 'blur'
        }],
        activitySharePic: [{
          required: true,
          message: '请上传活动分享海报',
          trigger: 'blur'
        }],
        tagPic: [{
          required: true,
          message: '请上传标签图',
          trigger: 'blur'
        }],
        color: [{
          required: true,
          message: '请输入背景色值',
          trigger: 'blur'
        }],
        activityTxt: [{
          required: true,
          message: '请输入活动规则文案',
          trigger: 'blur'
        }],
        timeArray: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }]
      },
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default',
      // or 'simple'
      EditorOpen: true
    };
  },
  created: function created() {
    this.activityList();
    this.getTljPidUseInfo();
  },
  beforeDestroy: function beforeDestroy() {
    var editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated: function onCreated(editor) {
      console.log('初始化', editor);
      this.editor = Object.seal(editor);
    },
    // 列表
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.activityList();
    },
    initQueryData: function initQueryData() {
      this.queryData = {
        activityName: '',
        status: null,
        page: {
          page: 1,
          size: 10
        }
      };
    },
    onInitialize: function onInitialize() {
      this.initQueryData();
      this.activityList();
    },
    activityList: function () {
      var _activityList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.tableLoading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 1;
              return (0, _marketingEvents.activityList)(params);
            case 1:
              res = _context2.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function activityList() {
        return _activityList2.apply(this, arguments);
      }
      return activityList;
    }(),
    getTljPidUseInfo: function () {
      var _getTljPidUseInfo2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                type: 1
              };
              _context3.n = 1;
              return (0, _marketingFunction.getTljPidUseInfo)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                console.log('res', res);
                this.getTljPidUseInfoData = res.data;
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getTljPidUseInfo() {
        return _getTljPidUseInfo2.apply(this, arguments);
      }
      return getTljPidUseInfo;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.activityList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.activityList();
    },
    // 添加
    onAdd: function onAdd() {
      this.eventsType = 'add';
      this.initRuleForm();
      var end = new Date();
      var start = new Date();
      end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
      start.setHours(0, 0, 0, 0); // 设置为00:00:00
      end.setHours(23, 59, 59, 999); // 设置为23:59:59
      this.ruleForm.timeArray = [this.formatDate(start), this.formatDate(end)];
      this.dialogVisible = true;
    },
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    initRuleForm: function initRuleForm() {
      this.ruleForm = {
        id: null,
        activityName: '',
        targetUserType: null,
        subsidyNum: null,
        headerPic: '',
        // 头图
        tutorialsSharePic: '',
        // 教程图
        activitySharePic: '',
        // 活动分享海报
        tagPic: '',
        // 标签图
        color: '',
        activityTxt: null,
        // 规则文案
        timeArray: [],
        activityStartTime: '',
        //	活动开始时间
        activityEndTime: '' //	活动结束时间
      };
    },
    handleClose: function handleClose() {
      this.initRuleForm();
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    onPictureAddress: function onPictureAddress(data) {
      this.ruleForm[data.name] = data.pictureUrl;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      if (Number(this.ruleForm.targetUserType) === 1) {
        if (Number(this.ruleForm.subsidyNum) > 1) {
          return this.$message({
            type: 'warning',
            message: '末出单用户，每人限购次数请设置为1'
          });
        }
      }
      if (Number(this.ruleForm.targetUserType) === 2) {
        if (Number(this.ruleForm.subsidyNum) > 1) {
          return this.$message({
            type: 'warning',
            message: '90天内末出单用户，每人限购次数请设置为1'
          });
        }
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm("\u662F\u5426\u786E\u8BA4".concat(_this.eventsType === 'add' ? '添加' : '编辑', "\u6B64\u6D3B\u52A8?"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            if (_this.eventsType === 'add') {
              _this.onSave();
            } else {
              _this.upData();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.initRuleForm();
      this.$refs[formName].resetFields();
    },
    onSave: function () {
      var _onSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              if (this.ruleForm.timeArray[0]) {
                this.ruleForm.activityStartTime = this.ruleForm.timeArray[0];
                this.ruleForm.activityEndTime = this.ruleForm.timeArray[1];
              }
              delete this.resetForm.timeArray;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context4.n = 1;
              return (0, _marketingEvents.save)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$message({
                  message: '新增成功',
                  type: 'success'
                });
                this.resetForm('ruleForm');
                this.dialogVisible = false;
                this.activityList();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function onSave() {
        return _onSave.apply(this, arguments);
      }
      return onSave;
    }(),
    // 编辑
    controls: function controls(val) {
      var _this2 = this;
      if (val.type === 'editor') {
        this.initRuleForm();
        this.eventsType = 'editor';
        var data = val.item;
        this.ruleForm.id = data.id;
        this.ruleForm.activityName = data.activityName;
        this.ruleForm.targetUserType = data.targetUserType;
        this.ruleForm.subsidyNum = data.subsidyNum;
        this.ruleForm.headerPic = data.headerPic;
        this.ruleForm.tutorialsSharePic = data.tutorialsSharePic;
        this.ruleForm.activitySharePic = data.activitySharePic;
        this.ruleForm.tagPic = data.tagPic;
        this.ruleForm.color = data.color;
        this.ruleForm.activityTxt = data.activityTxt;
        if (data.activityStartTime) {
          this.ruleForm.timeArray = [data.activityStartTime, data.activityEndTime];
        }
        this.dialogVisible = true;
      } else {
        this.$confirm("\u662F\u5426\u786E\u8BA4\u5220\u9664\u6B64\u6D3B\u52A8?", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.deleteById(val.item.id);
        });
      }
    },
    upData: function () {
      var _upData2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              // this.ruleForm.activityStartTime = this.ruleForm.timeArray[0]
              // this.ruleForm.activityEndTime = this.ruleForm.timeArray[1]
              if (this.ruleForm.timeArray[0]) {
                this.ruleForm.activityStartTime = this.ruleForm.timeArray[0];
                this.ruleForm.activityEndTime = this.ruleForm.timeArray[1];
              }
              delete this.resetForm.timeArray;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context5.n = 1;
              return (0, _marketingEvents.upData)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                });
                this.resetForm('ruleForm');
                this.dialogVisible = false;
                this.activityList();
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function upData() {
        return _upData2.apply(this, arguments);
      }
      return upData;
    }(),
    // 删除
    deleteById: function () {
      var _deleteById2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(id) {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                id: id
              };
              _context6.n = 1;
              return (0, _marketingEvents.deleteById)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.activityList();
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.log(_t6);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function deleteById(_x3) {
        return _deleteById2.apply(this, arguments);
      }
      return deleteById;
    }()
  }
};